import ServiceHelper from "./service.helper";

export default class PatientReferralService{
    static createPatientReferral(payload){
        return;
        return ServiceHelper.postRequestHandler(`/patient-referral`,payload)
    }

    static getCOEStaffReferrals(query = ''){
        return ServiceHelper.getRequestHandler(`/patient-referral/coe-staff?${query}`);
    }

    static getCOEReferrals(query = ''){
        return ServiceHelper.getRequestHandler(`/patient-referral/coe`);
    }

    static assignToStaff(payload){
        return;
        return ServiceHelper.patchRequestHandler(`/patient-referral/assign-to-staff`, payload);
    }

    static attendToReferal(payload){
        return;
        return ServiceHelper.patchRequestHandler(`/patient-referral/attend-to-referral`, payload);
    }

    static approveReferral(payload){
        return;
        return ServiceHelper.patchRequestHandler(`/patient-referral/approve`,payload);
    }
}